/* eslint-disable no-console */

export default function warnInDev(message) {
    if (process.env.NODE_ENV === 'development') {
        console.warn(message);
    }
}
